import { render, staticRenderFns } from "./DeliveryPerPriceByHub.vue?vue&type=template&id=63c0f56f&lang=pug&"
import script from "./DeliveryPerPriceByHub.vue?vue&type=script&lang=ts&"
export * from "./DeliveryPerPriceByHub.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryPerPriceByHub.vue?vue&type=style&index=0&id=63c0f56f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports